import cn from 'classnames';
import React from 'react';
import { HeaderNew } from 'src/entities/_headers/Header/ui/HeaderNew/HeaderNew';
import { DivProps } from 'src/shared/types/props';
import s from './PageDecorator.module.scss';

interface Props extends DivProps {}

export const PageDecorator: React.FC<Props> = (props) => {
	const {
		children, //
		className,
		...divProps
	} = props;

	// * Render
	return (
		<div
			{...divProps}
			className={cn(s.container, className)}
		>
			<HeaderNew />

			<div className={s.content}>{children}</div>

			{/* footer. If footer is required he must contain margin-top: auto; for it to be stuck to the bottom of the page. */}
		</div>
	);
};
